import Nullstack from 'nullstack';
export default function IconGenderIntergender({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-intergender",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 11.5l6.5 6.5v-4"
  }), "   ", Nullstack.element("path", {
    d: "M11.5 13.5l6.5 6.5"
  }), "   ", Nullstack.element("path", {
    d: "M9 4a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
  }), "   ", Nullstack.element("path", {
    d: "M14 20l2 -2"
  }), " ");
}